import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchClientsApi } from '../services/adminClients'

const getUserId = (state) => {
  const id = state.auth?.userData?.id
  if (id) return id

  try {
    const token = localStorage.getItem('access_token')
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.sub || payload.id || payload.user_id || null
    }
  } catch (e) {}

  return null
}

export const fetchClients = createAsyncThunk(
  'adminClients/fetchClients',
  async (clientUserId, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const { offset } = state.adminClients
      const userId = getUserId(state)

      if (!userId) {
        return thunkAPI.rejectWithValue('SESSION_EXPIRED')
      }

      return await fetchClientsApi({ offset, userId, clientUserId })
    } catch (err) {
      return thunkAPI.rejectWithValue(err.type || err.message || 'Error desconocido')
    }
  }
)

const initialState = {
  users: [],
  total: 0,
  limit: 50,
  offset: 0,
  loading: false,
  error: null
}

const adminClientsSlice = createSlice({
  name: 'adminClients',
  initialState,
  reducers: {
    setOffset: (state, action) => {
      state.offset = action.payload
    },
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.loading = false
        state.users = action.payload.users
        state.total = action.payload.total
        state.limit = action.payload.limit
        state.offset = action.payload.offset
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Error desconocido'
        state.users = []
      })
  }
})

export const { setOffset, clearError } = adminClientsSlice.actions

export const selectClients = (state) => state.adminClients.users
export const selectClientsTotal = (state) => state.adminClients.total
export const selectClientsLimit = (state) => state.adminClients.limit
export const selectClientsOffset = (state) => state.adminClients.offset
export const selectClientsLoading = (state) => state.adminClients.loading
export const selectClientsError = (state) => state.adminClients.error

export default adminClientsSlice.reducer
